import React from "react";
import * as S from "./Artists.styled";

const artistsData = [
  {
    name: "PETAR LUBARDA",
    text: "je rođen 1907. u Ljubotinju nedaleko od Cetinja, od oca Đura I. Lubarde, oficira crnogorske vojske, a potom potpukovnika Vojske Kraljevine Jugoslavije, i majke Marije M. Vujović, domaćice. Imao je petoro braće i sestara.",
    image: "images/umetnik_1_srednja3.jpg",
    link: "/g/petar-lubarda",
    width: 220,
    height: 173,
  },
  {
    name: "SAVA ŠUMANOVIĆ",
    text: "je rođen 24. januara 1896. u Vinkovcima u imućnoj građanskoj porodici, Perside i Milutina Šumanovića. Posle ranog očevog penzionisanja 1900. porodica se vraća u Šid, gde Sava pohađa osnovnu školu.",
    image: "images/umetnik_2_srednja3.jpg",
    link: "/g/sava-sumanovic",
    width: 220,
    height: 172,
  },
  {
    name: "NADEŽDA PETROVIĆ",
    text: "je rođena 11. oktоbra 1873. u Čačku. Otac Dimitrije Mita Petrović bio je nastavnik crtanja u Realnoj gimnaziji u Čačku, a majka Mileva učiteljica. Nadežda je bila najstarije od devetoro dece.",
    image: "images/nadezda-petrovic-s3.jpg",
    link: "/g/nadezda-petrovic",
    width: 220,
    height: 326,
  },
];

const Artists: React.FC = () => {
  return (
    <S.Container>
      <S.Row>
        <S.Col>
          <S.Title>UMETNICI</S.Title>

          <S.ArtistWrapper>
            {artistsData.map((artist, index) => (
              <S.ArtistRow key={index} $last={index === artistsData.length - 1}>
                <S.ImageColumn>
                  <S.Link href={artist.link}>
                    <S.Image
                      src={artist.image}
                      alt={artist.name}
                      width={artist.width}
                      height={artist.height}
                    />
                  </S.Link>
                </S.ImageColumn>

                <S.TextColumn>
                  <S.ArtistText>
                    <S.ArtistName>{artist.name}</S.ArtistName>
                    <p>{artist.text}</p>
                    <S.Link href={artist.link}>dalje...</S.Link>
                    <S.Link href={artist.link}>
                      <S.ArrowIcon
                        src="images/strelica.jpg"
                        alt="Strelica"
                        width={15}
                      />
                    </S.Link>
                  </S.ArtistText>
                </S.TextColumn>
              </S.ArtistRow>
            ))}
          </S.ArtistWrapper>
        </S.Col>
      </S.Row>
    </S.Container>
  );
};

export default Artists;
